namespace RioERP.Invoices {
    export interface InvoiceHsnForm {
        OrderId: Serenity.LookupEditor;
        HsnMasterId: Serenity.LookupEditor;
        TaxCategoryId: Serenity.LookupEditor;
        TaxableAmount: Serenity.DecimalEditor;
        TaxTypeId: Serenity.LookupEditor;
        TaxAmount: Serenity.DecimalEditor;
    }

    export class InvoiceHsnForm extends Serenity.PrefixedContext {
        static formKey = 'Invoices.InvoiceHsn';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!InvoiceHsnForm.init)  {
                InvoiceHsnForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(InvoiceHsnForm, [
                    'OrderId', w0,
                    'HsnMasterId', w0,
                    'TaxCategoryId', w0,
                    'TaxableAmount', w1,
                    'TaxTypeId', w0,
                    'TaxAmount', w1
                ]);
            }
        }
    }
}
